import { NgClass, SlicePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSliderModule } from '@angular/material/slider';
import { I18NextModule } from 'angular-i18next';
import { DateRange } from 'src/app/common/utils/helpers';
import { IconComponent } from '../../../common/icon/icon.component';
import { RangeCalendarComponent } from '../../../_shared/components/range-calendar/range-calendar.component';

@Component({
  selector: 'sharry-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    SlicePipe,
    MatExpansionModule,
    MatCheckboxModule,
    I18NextModule,
    IconComponent,
    RangeCalendarComponent,
    MatSliderModule,
    MatButtonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterComponent implements OnChanges {
  @Input() filters: { id: string; text?: string; name?: string; icon?: { url?: string } }[] = [];
  @Input() searchFilters: string[] = [];
  @Input() filterTitle: string;
  @Input() dateRange: DateRange<Date>;
  @Input() distance = 0;
  @Input() icon: string;
  @Input() type: 'checkbox-list' | 'calendar' | 'slider';
  @Input() noBorderTop = false;
  @Input() borderBottom = false;
  @Input() expanded = false;

  @Input() get maxFilters() {
    return this._maxFiltersBackup;
  }

  set maxFilters(n: number) {
    this._maxFiltersBackup = n;
    this._maxFilters = n;
  }

  @Output() distanceChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() dateRangeChange: EventEmitter<DateRange<Date>> = new EventEmitter<DateRange<Date>>();

  _maxFilters = 0;
  _maxFiltersBackup = 0;
  today: Date = new Date();

  constructor(private cd: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.expanded?.currentValue) {
      this.onToggleMaxFilters();
    }
    if (changes?.filters?.currentValue) {
      this.filters = [...changes.filters.currentValue].sort((a, b) => {
        if (a.name?.length) {
          return a.name === b.name ? 0 : a.name > b.name ? 1 : -1;
        } else {
          return a.text === b.text ? 0 : a.text > b.text ? 1 : -1;
        }
      });
    }
  }

  onCheckboxClick(filter: { id: string; text?: string; name?: string }, checked: boolean) {
    if (checked) {
      this.searchFilters.push(filter.id);
    } else {
      this.searchFilters.splice(this.searchFilters.indexOf(filter.id), 1);
    }
  }

  formatLabel(value: number) {
    return `${value}`;
  }

  onCleanFilter() {
    this.dateRange = undefined;
    this.dateRangeChange.emit(undefined);
    this.cd.detectChanges();
  }

  onClearList() {
    this.searchFilters.splice(0, this.searchFilters?.length);
    this.cd.detectChanges();
  }

  onSelectAllList() {
    this.searchFilters.push(...this.filters.map(f => f.id));
  }

  onToggleMaxFilters() {
    if (this.filters?.length === this._maxFilters) {
      this._maxFilters = this._maxFiltersBackup;
    } else {
      this._maxFilters = this.filters?.length;
    }
  }
}
